import { __rest, __assign } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';

var FacebookCircleColorLogomarkIcon = function (_a) {
    var title = _a.title, props = __rest(_a, ["title"]);
    return (jsxs("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", "data-ui-icon": true }, props, { children: [title ? jsx("title", { children: title }) : null, jsx("path", { d: "M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12z", fill: "#1877F2" }), jsx("path", { d: "M15.886 14.887l.442-2.882H13.55v-1.873c0-.793.401-1.565 1.637-1.565h1.255v-2.45s-1.132-.206-2.223-.206c-2.285 0-3.767 1.39-3.767 3.891v2.203H7.898v2.882h2.553v6.99c.504.082 1.029.123 1.554.123.525 0 1.05-.041 1.554-.124v-6.989h2.327z", fill: "#fff" })] })));
};

export { FacebookCircleColorLogomarkIcon };
//# sourceMappingURL=FacebookCircleColorLogomarkIcon.js.map
